import axios from 'axios'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useSessionStorage } from 'react-use'

export default function useToken() {
  const router = useRouter()
  const { token: adminAuthToken } = router.query
  const [cookies] = useCookies(['auth_token', 'user_name'])
  const backLink = `${process.env.base_api.split('/api')[0]}/admin/quiz`
  const [adminToken, setAdminToken] = useSessionStorage('admin-token')

  // useEffect(() => {
  //   if (router.isReady) {
  //     if (
  //       adminAuthToken ||
  //       adminToken !== 'false' ||
  //       adminToken !== 'pending'
  //     ) {
  //       axios
  //         .get(`${process.env.base_api}/auth/current-user`, {
  //           headers: {
  //             Accept: 'application/json',
  //             'X-Requested-With': 'XMLHttpRequest',
  //             Authorization: `Bearer ${adminAuthToken}`
  //           }
  //         })
  //         .then(function () {
  //           setAdminToken(adminAuthToken)
  //         })
  //         .catch(function (err) {
  //           setAdminToken(false)
  //           router.push(backLink)
  //         })
  //     } else {
  //       setAdminToken(false)
  //     }
  //   }
  // }, [adminAuthToken, router.isReady])

  useEffect(() => {
    if (router.pathname.includes('/password-reset')) {
      return
    }
    if (adminAuthToken) {
      axios
        .get(`${process.env.base_api}/auth/current-user`, {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: `Bearer ${adminAuthToken}`
          }
        })
        .then(function () {
          setAdminToken(adminAuthToken)
        })
        .catch(function (err) {
          setAdminToken(false)
          router.push(backLink)
        })
    }
  }, [adminAuthToken])

  useEffect(() => {
    if (!adminToken && !cookies.auth_token) {
      console.log('pusing to login')
      //router.push('/login')
    }
  }, [adminToken, cookies.auth_token])

  const cookieToken = cookies.auth_token
  const sessionToken =
    typeof window !== 'undefined' ? sessionStorage.getItem('auth_token') : null

  useEffect(() => {
    if (cookieToken && cookieToken !== sessionToken) {
      sessionStorage.setItem('auth_token', cookieToken)
    }
  }, [cookieToken])

  return {
    token: cookieToken || sessionToken || false,
    adminToken: adminToken
  }
}
